import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import FileUploadElement from "../../../../ReusableComponents/UploadFile/uplaodFile";
import ListFinInsurance from "./ListFinInsurance";
import { getFinInsuranceData } from "../../../../store/Api";




export default function FinInsurance(props) {
    const insuranceList = useSelector((state) => state.finInsuranceData);

    //screen Title Show fun
    const dispatch = useDispatch();
    const titleBorder = [{ label: 'Insurance Vendor payment ', link: '/dashboard/AtmPayroll' }];
    useEffect(() => {
        dispatch(setBreadCrumb(titleBorder));
        dispatch(getFinInsuranceData(token));
    }, []);

    const [loading, setLoading] = useState({
        updateData: false,
        uploadFile: false,
        listData: false,
        loadingId: "",
    });
    const token = localStorage.getItem("nodeToken");



    const updateData = () => {
        dispatch(getFinInsuranceData(token));
    };

    const [showPromptElement, setShowPromptElement] = useState({
        open: false,
    });

    const uploadFile = async (file) => {
        console.log(file)
        if (file) {
            setLoading((p) => ({ ...p, loadingId: file }));
            try {
                const response = await axios.get(`/employees/updateBorderNumbersFromExcel/${file}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (response.status === 200) {
                    apiCall()
                    setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
                    dispatch(
                        setAppError({
                            msg: response.data.message,
                            color: "bg-green-700",
                        })
                    );
                }
            } catch (err) {
                if (err?.response?.status === 403) {
                    if (err?.response?.data?.message) {
                        dispatch(
                            setAppError({
                                msg: err?.response?.data.message,
                            })
                        );
                    }
                }
                setLoading((p) => ({ ...p, delete: false }));
                dispatch(
                    setAppError({
                        msg: err.message,
                    })
                );
            }
        }
    }
    return (
        <div className={`ml-5 mr-5`}>
            {showPromptElement.open && (
                <FileUploadElement
                    title={"Upload Tamplate with Border Number"}
                    subTitle={"Upload templete"}
                    showFileUploadElement={showPromptElement}
                    setShowFileUploadElement={setShowPromptElement}
                    uploadFile={uploadFile}
                />
            )}

            <ListFinInsurance
                list={insuranceList}
                loading={loading}
                titles={["S.NO.",
                    "EMPLOYEE ID",
                    // "VISA PROVIDER",
                    // "CLIENT NAME",
                    "RELATION",
                    "MARITAL STATUS",
                    "CLASS",
                    "HEAD OF FAMILY BUPA ID IF ADDING DEPENDENTS",
                    "POLICY NO",
                    "APPLY DATE",
                    "ISSUE DATE",
                    "INSURANCE COMPANY",
                    "MEMBERSHIP NO",
                    "INSURANCE NO",
                    "INSURANCE STATUS",
                    "POLICY COVERAGE DAYS",
                    "TOTAL AMOUNT",
                    "PAID AMOUNT",
                    "INVOICE NUMBER",
                    "status",
                    "Action"
                ]}
                token={token}
                updateData={updateData}
                uploadFile={setShowPromptElement}
            />
        </div>
    );
}
